<template>
  <div class="article-card" @click="handleClick">
    <img v-if="article.coverImage" :src="article.coverImage" class="article-card__cover" :alt="article.title" />
    <div class="article-card__header">
      <div class="article-card__title">{{ article.title }}</div>
      <div v-if="article.subTitle" class="article-card__subtitle">{{ article.subTitle }}</div>
    </div>
    <div class="article-card__body">
      <div class="article-card__footer">
        <div class="article-card__date">{{ formatDate(article.createTime) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/format'

export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.article)
    },
    formatDate
  }
}
</script>

<style lang="scss" scoped>
.article-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 12px;
  margin-bottom: 12px;
  transition: all 0.3s ease;

  &:active {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  &__cover {
    width: 100%;
    height: 140px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 12px;
    display: block;
  }

  &__header {
    margin-bottom: 12px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__subtitle {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__body {
    border-top: 1px solid #f3f4f6;
    padding-top: 12px;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }

  &__date {
    font-size: 12px;
    color: #9ca3af;
  }
}
</style>
